<div class="nacho-wrap">
    <div class="container">
        <div class="row text-center">
            <div class="col-12">
                <h2>Nacho Art Gallery</h2>
                <p class="mb-0">Thanks to all who came and donated!</p>
                <p>We raised $671 for St. Judes research hospital!</p>
                <div class="st-jude"></div>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col-md-6" *ngFor="let art of gallery">
                <div class="art-box text-center" data-toggle="modal" data-target="#artShowModal" (click)="changeModal(art)">
                    <div class="top-ammount mb-2" *ngIf="!art.dontSell">{{getTopBid(art.bids)}}</div>
                    <div class="top-ammount mb-2" *ngIf="art.dontSell">Already Sold!</div>
                    <div class="nacho-art {{art.img}}"></div>
                    <h3>{{art.title}}</h3>
                    <p>-{{art.author}}</p>
                </div>
            </div>
        </div>
    </div>
    
    <!-- <input type="text" [(ngModel)]="author" placeholder="author">
    <input type="text" [(ngModel)]="title" placeholder="title">
    <input type="text" [(ngModel)]="img" placeholder="img">
    <button (click)="addArt()">Add Art</button> -->

</div>
 

<!-- Project Modal -->
<div class="modal fade" id="artShowModal" tabindex="-1" role="dialog" aria-labelledby="artShowModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content color5">
            <button type="button" class="color5 custom-close" data-dismiss="modal" aria-label="Close">
                <span data-dismiss="modal" aria-label="Close">&times;</span>
            </button>
            <div class="modal-body row align-items-center">
                <div class="col-sm">
                    <div class="text-center">
                        <div class="modal-art-image {{featuredArt.img}}"></div>
                        <h3>{{featuredArt.title}}</h3>
                        <p>-{{featuredArt.author}}</p>
                    </div>
                    <!-- <div class="lil-form text-center">
                        <input type="text" class="mt-2" [(ngModel)]="bidderName" placeholder="Your name">
                        <input class="mt-2" type="number" min="1" step="1" onkeypress="return event.charCode >= 48 && event.charCode <= 57" [(ngModel)]="bidAmmount" placeholder="Bid Ammount">
                        <br class="d-md-none">
                        <button class="button btn btn-primary ml-3 mt-2" (click)="submitBid(featuredArt.key)">Place Bid</button>
                        <button *ngIf class="button btn btn-primary ml-3 mt-2" (click)="submitBid(featuredArt.key)">Place Bid</button>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</div>